import { toPx } from "./style";

/* 设置字体rem */

let useRem = false

function onWindowResize() {
    let root = document.documentElement
    let fontSize = 14
    if (useRem) {
        var width = document.body.offsetWidth; // 获取当前页面的宽度
        fontSize = width / 1920; // 设置字体大小    
    }
    console.log(fontSize, "fontSize");
    root.style.fontSize = toPx(fontSize);
}

export function setRem() {
    useRem = true
    onWindowResize()
}

export function unsetRem() {
    useRem = false    
    onWindowResize()
}

unsetRem()

window.addEventListener("resize", () => {
    onWindowResize();
})
